import { isValidE164Phone, normalizePhone } from "./phone";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Jedno pole kontaktu w quizie -> pola, które przyjmuje bramka /api/leads.
export function classifyContact(raw) {
  const contact = (raw || "").trim();
  if (EMAIL_REGEX.test(contact)) return { phone: "", email: contact, telegram: "" };
  if (isValidE164Phone(contact)) return { phone: normalizePhone(contact), email: "", telegram: "" };
  return { phone: "", email: "", telegram: contact };
}
